export const isMembershipsPromotion = (promotion) => promotion.type === 'MEMBERSHIPS_SINGLE' || promotion.type === 'MEMBERSHIPS_MULTI';
